import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { CompanyTopPresenter } from "./presenter";
import { useCompanyTopQuery } from "./repository/use-company-top-query";

export const CompanyTopContainer = () => {
	const { data } = useCompanyTopQuery();

	if (!data) {
		throw new Error("ホテルのデータが取得できませんでした");
	}

	if (data.hotelList.hotels.length === 0) {
		return <Navigate to={generatePath(PATHS.SETUP)} />;
	}

	return <CompanyTopPresenter hotelList={data.hotelList} />;
};

CompanyTopContainer.displayName = "CompanyTopContainer";
